const hasApiKey = state => state.hasApiKey
const apiKey = state => state.token
const startDate = state => state.startDate
const endDate = state => state.endDate
const status = state => state.status
const latestMonthUsage = state => state.usage.latestMonth
const dailyUsage = state => state.usage.daily

export default {
    hasApiKey,
    apiKey,
    startDate,
    endDate,
    status,
    latestMonthUsage,
    dailyUsage
}
